import { createBrowserHistory } from 'history';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import { routerMiddleware } from './external/connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';

export const history = createBrowserHistory();

const initialState = {};
const enhancers = [];
const middleware = [
  thunk,
  routerMiddleware(history),
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

const store = createStore(rootReducer(history), initialState, composedEnhancers);

export default store;
